import { MenuItem, TextField } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { FieldError } from "react-hook-form";
import { WaterAccountsData } from "../models/WaterAccount";
import { getWaterAccounts } from "../repositories/WaterAccountRepository";

export const useWaterAccounts = () =>
	useQuery<WaterAccountsData, Error>({
		queryKey: ["water-accounts"],
		queryFn: ({ signal }) => getWaterAccounts(signal),
		staleTime: 300_000,
	});

type Props = {
	label?: string;
	value: number | null;
	onChange?: Function;
	disabled?: boolean;
	fieldError?: FieldError;
};

export const WaterAccountSelector = ({
	label = "Account #",
	value,
	onChange = () => {},
	disabled = false,
	fieldError,
}: Props) => {
	const { data, isLoading } = useWaterAccounts();
	const accounts = data?.accounts.filter((a) => a.IsSelectable) ?? [];

	const selectedValue =
		accounts.find((account) => account.WaterAccountId === value)
			?.WaterAccountId ?? "";

	return (
		<TextField
			select
			fullWidth
			size="small"
			label={label}
			value={selectedValue}
			disabled={disabled || isLoading}
			error={!!fieldError}
			helperText={fieldError?.message}
			onChange={(event) => onChange(Number(event.target.value))}
			inputProps={{ "data-test-id": "water-account-selector" }}
		>
			{accounts.map((account) => (
				<MenuItem key={account.WaterAccountId} value={account.WaterAccountId}>
					{account.AccountNumber}
				</MenuItem>
			))}
		</TextField>
	);
};
